<template>
  <div
    class="bg-gray-100 smt-0 pb-20 lg:pt-4 lg:mt-4 xl:mt-4 lg:pb-4 xl:pb-4 text-gray-600 font-open-sans flex flex-col flex-grow content-center"
  >
    <div class="flex flex-row flex-grow bg-white -mt-4"></div>
    <div class="flex flex-row bg-gray-100 border-gray-400 border-t">
      <div class="flex-grow"></div>
      <div class="text-center align-text-bottom">
        <div class="hidden lg:block xl:block">
          <p class="uppercase font-semibold">
            <a href="https://www.mulierinstituut.nl" target="_blank"
              >Mulier Instituut</a
            >
          </p>
          <p class="truncate">Herculesplein 269</p>
          <p class="truncate">3584 AA Utrecht</p>
        </div>

        <a href="https://www.mulierinstituut.nl" target="_blank"
          ><img
            src="../assets/logo_trans.png"
            class="lg:hidden xl:hidden h-20 p-4"
            alt="logo Mulier"
        /></a>
        <p>
          <a href="mailto:ams@mulierinstituut.nl">ams@mulierinstituut.nl</a>
        </p>
      </div>
      <div class="flex-grow"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
